<template>
	<div class="layout-profile">
		<div>
			<Avatar image="assets/layout/images/profile.png" class="p-mr-2" size="large" shape="circle" />
		</div>
		<button class="p-link layout-profile-link" @click="onClick">
			<span class="username"><b>{{datosdocente.email}}</b></span>
			<i class="pi pi-fw pi-cog"></i>
		</button>
        <transition name="layout-submenu-wrapper">
            <ul v-show="expanded">
                <li><button class="p-link"><i class="pi pi-fw pi-user"></i><span>Cuenta de Usuario</span></button></li>                                
            </ul>
        </transition>
		
	</div>
</template>

<script>
import apiDatosDocente from '@/service/DatosDocenteService';
import apiDatosPersonal from '@/service/DatosPersonalService';

	export default {
		data() {
			return {
				datosdocente: {},
				expanded: false
			}
		},
		created() {
			this.initialize();			
		},
		mounted() {
			this.getDatosDocente();			
		},
		methods: {
			onClick(event){
				this.expanded = !this.expanded;
				event.preventDefault();
			},
			initialize () {
				this.getDatosDocente();			
			}, 
			getDatosDocente: async function() {   //Leer datos desde el API REST
				const noPlazaUser = window.localStorage.getItem('noPlaza');
				
				const data = await apiDatosDocente.getDatosCuentaDocente(noPlazaUser);
				this.datosdocente = data;
				const datospersonal = await apiDatosPersonal.getDatosPersonal(noPlazaUser);
				const nombreUser = ' ' + datospersonal.nombreDocente + ' ' + datospersonal.apellidoPaterno + ' ' + datospersonal.apellidoMaterno + ' ';
				window.localStorage.setItem('nombreDocenteUser', nombreUser);
				
			}
		}
	}
</script>

<style scoped>

</style>